<template>
  <router-view :key="routePath" />
</template>

<script>
import { computed } from "@vue/composition-api";

export default {
  name: "SafeHarborPage",
  components: {},
  props: {},
  setup(props, { root }) {
    const routePath = computed(() => root.$route.fullPath);

    return {
      routePath,
    };
  },
};
</script>
